import {createAction} from '@reduxjs/toolkit'
import {getMemberId} from '../selectors/user'
import {createAsyncAction} from '../services/redux-toolkit'

export const getMyTickets = createAsyncAction<{tickets: wix.events.ticketing.Ticket[]}, {eventId: string}>(
  'GET_MY_TICKETS',
  async ({eventId}, {getState, extra: {serverApi}}) => serverApi.getMyTickets(eventId, getMemberId(getState())),
)

export const downloadTicketsAction = createAction<string>('DOWNLOAD_TICKETS_ACTION')
